import React from "react";
import { addDays, endOfMonth, endOfWeek, format, isSameMonth, startOfMonth, startOfWeek } from "date-fns";
import { URGENCY, isoOf } from "@/lib/brand";

export const monthRange = (cursor) => {
  const start = startOfWeek(startOfMonth(cursor));
  const end = endOfWeek(endOfMonth(cursor));
  return { start, end };
};

export function MonthGrid({ cursor, events, selected, onSelect, today, compact, onEventClick }) {
  const { start, end } = monthRange(cursor);
  const byDate = {};
  events.forEach((e) => { (byDate[e.date] = byDate[e.date] || []).push(e); });
  const days = [];
  for (let d = start; d <= end; d = addDays(d, 1)) days.push(d);
  return (
    <div data-testid="month-grid">
      <div className="grid grid-cols-7 text-[0.7rem] font-semibold text-[var(--pm-muted)] mb-2">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d} className="text-center py-1">{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {days.map((d) => {
          const iso = isoOf(d);
          const evs = byDate[iso] || [];
          const isSel = selected === iso;
          const isToday = today === iso;
          const muted = !isSameMonth(d, cursor);
          return (
            <button key={iso} onClick={() => onSelect?.(iso)} data-testid={`cal-day-${iso}`}
              className={`rounded-xl text-sm transition-colors flex flex-col ${compact ? "h-11 items-center justify-center" : "min-h-[96px] p-1.5 items-stretch text-left"}
                ${isSel ? "bg-[var(--pm-primary)] text-white" : isToday ? "bg-[#EFEBFF] text-[var(--pm-primary)] font-bold" : "hover:bg-[#F6F4FD]"} ${muted && !isSel ? "opacity-40" : ""}`}>
              <span className={compact ? "" : "text-xs font-semibold px-1"}>{format(d, "d")}</span>
              {compact ? (
                evs.length > 0 && <span className="flex gap-0.5 mt-0.5">{evs.slice(0, 3).map((e, i) => <span key={i} className="w-1.5 h-1.5 rounded-full" style={{ background: isSel ? "#fff" : URGENCY[e.urgency]?.dot }} />)}</span>
              ) : (
                <span className="flex flex-col gap-1 mt-1">
                  {evs.slice(0, 3).map((e) => (
                    <span key={e.reminder_id + e.date} role="link" tabIndex={0}
                      onClick={(ev) => { ev.stopPropagation(); onEventClick?.(e); }}
                      className={`truncate text-[0.68rem] font-semibold rounded-md px-1.5 py-0.5 ${isSel ? "bg-white/20 text-white" : URGENCY[e.urgency]?.cls}`}
                      data-testid={`cal-event-${e.reminder_id}-${e.date}`}>{e.title}</span>
                  ))}
                  {evs.length > 3 && <span className="text-[0.65rem] px-1.5">+{evs.length - 3} more</span>}
                </span>
              )}
            </button>
          );
        })}
      </div>
      <div className="flex flex-wrap gap-4 mt-4 text-xs text-[var(--pm-muted)]">
        {["overdue", "due_soon", "upcoming", "completed"].map((k) => <span key={k} className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full" style={{ background: URGENCY[k].dot }} />{URGENCY[k].label}</span>)}
      </div>
    </div>
  );
}
